module.exports = __webpack_public_path__ + "static/img/login_bg.b1f89ef.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.jpeg
// module id = z3nL
// module chunks = 29